<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="18" :md="14">
        <div class="news">
            <h1>飞康生物基层检测新利器亮相2025年杭州CACLP展</h1>
            <p>  当基层诊所因设备简陋而延误病情判断，当家庭健康监测只能依赖模糊的定性结果，当传统检测耗时耗力难以普及……苏州飞康生物医药有限公司以硬核科技打破困局，推出全新“胶体金+荧光免疫层析一体机”，将实验室级精准检测压缩至数分钟，让基层医生和家庭用户真正实现“一机在手，健康无忧”。</p>
            <img src="@/assets/images/information/2503202.jpg" alt="">
            <p class="s-title">破局基层医疗：双核技术开启精准检测新时代</p>
            <p>  作为专注院外健康检测的高科技企业，苏州飞康由海归博士团队创立，深耕智能医疗硬件研发，2023年获亿生资本1500万元战略投资。其最新推出的POCT一体机，以 “胶体金+荧光免疫层析”双技术融合让人印象深刻——通过巧妙的光路设计和强大的云端算法，灵敏度较传统胶体金技术提升10倍，荧光定量检测准确度与医用荧光分析仪高度一致（R²>0.99）。</p>
            <p>  临床验证数据亮眼：在与上海多家医院的对比试验中，C反应蛋白（CRP）检测误差率&lt;5%，甲/乙流病毒检出时间缩短至8分钟。这意味着基层诊所无需昂贵设备，也能获得三甲医院的检测质量。</p>
            <p class="s-title">三大创新引擎，重新定义POCT标准</p>
            <p>  1.	创新云计算模式，破解基层检测难题</p>
            <p>  云计算：图像算法全部部署在云端，享有服务器的澎湃AI算力；宽动态图像识别算法：无论试剂条的信号是极弱还是极强，算法都能精准识别和定量试剂条；  机器学习动态分析算法：实时学习，持续优化，使幽门螺杆菌分型等复杂项目的检测稳定性和准确率提升40%。</p>
            <p>  2.全场景覆盖：从急诊到慢病，一机搞定12+需求</p>
            <p>  设备支持咽拭子、末梢血、尿液等多样本类型，覆盖四大核心场景：  感染防控：3分钟CRP筛查炎症，15分钟鉴别甲/乙流；  慢病管理：糖化血红蛋白检测助力糖尿病随访；  女性健康：早孕HCG、排卵监测等居家自测；  胃肠健康：幽门螺杆菌分型快速筛查。  通过开放式平台，医疗机构还可随时升级新增项目，无需更换设备即可适配定制试剂条，真正实现“一次投入，终身迭代”。</p>
            <p>  3.	极简操作：三步完成专业级检测</p>
            <p>  飞康深谙基层用户需求，将检测流程极致简化： (1)滴加样本 → (2)插入试剂卡 → (3)扫码查看结果。即便是毫无经验的家庭用户，也能轻松完成操作。设备内置智能质控系统，若插卡错误或不到位，立即触发预警提示，从源头杜绝误诊风险。</p>
            <p class="s-title">国产智造突围：专利技术+千家诊所验证</p>
            <p>  飞康生物医药的研发实力与市场认可度双重加持：  核心技术自主可控：拥有中国发明专利（ZL2020115542198）及美国公示专利（US-2024-0003812-A1），构建严密技术护城河；  便携设计获青睐：小于A4纸大小的机身，可放置于诊所桌面或家庭药箱，却集成12项检测功能；  千家机构背书：产品已在全国13个省份的1000余家基层诊所落地，累计完成数万例检测。</p>
            <p>  “过去我们不敢接急诊发热患者，现在用飞康设备8分钟出结果，患者留存率提高了3倍。”贵州某诊所负责人分享道。而家庭用户则通过配套APP实现数据云端管理，慢性病患者可生成趋势图表，直接分享给主治医生。</p>
            <p class="s-title">飞康生物：让精准医疗走出医院，走进生活</p>
            <p>  从留学归国博士的实验室，到国产创新先锋，苏州飞康生物医药有限公司以 “智能硬件+AI软件+诊断试剂”的创新三角，重构居家和基层医疗场景。公司开发的院外健康检测系统，不仅是一台设备，更是一套覆盖“检测-分析-管理”的完整解决方案。</p>
            <p>  在分级诊疗与健康管理的大趋势下，飞康POCT一体机用科技填补了基层医疗机构与三甲医院的技术鸿沟。无论是社区诊所的快速检测，还是家庭的慢病监测，亦或是女性的健康管理，这台“口袋实验室”正在成为万千用户的“健康守门人”。  </p>
            
            <p class="s-title">【立即体验】</p>
            <p>欢迎参访2025年杭州CACLP展会7-A0004展台，获取产品单页，申请试用，洽谈合作，共同开启精准医疗普惠时代！</p>
            <img src="@/assets/images/information/2503201.jpg" alt="">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Cooperation",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  margin-top: 90px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  img{
    width:60%;
    height: auto;
    
  }
  .s-title{
    font-weight: bold;
    margin-top: 20px;
  }
  .imgtxt {
    text-align: center;
    margin-top: 5px;
  }
  p {
    line-height: 28px;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  h1,
  h2 {
    margin-top: 20px;
  }
}
</style>
